import { render, staticRenderFns } from "./similar_account.vue?vue&type=template&id=889d71c6&"
import script from "./similar_account.vue?vue&type=script&lang=js&"
export * from "./similar_account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports